import { FunctionComponent } from 'react'

import styled from 'styled-components'

import FreeRatioImage from '@components/FreeRatioImage'

const IMAGE = {
  src: '/incoming/21344797-v0-blick-plus-onboarding.png',
  alt: 'sport-image',
  width: 124,
  height: 254,
  crops: {
    '1_1': {
      x: 0,
      y: 65,
      width: 124,
      height: 124,
    },
    '9_16': {
      x: 0,
      y: 16,
      width: 124,
      height: 220,
    },
    free: {
      width: 124,
      height: 254,
      x: 0,
      y: 0,
    },
  },
} as const

const expectedDimensions = { width: 122, height: 250 } as const

const constraints = {
  desktop: expectedDimensions,
  tablet: expectedDimensions,
  mobile: expectedDimensions,
  mobileSmall: expectedDimensions,
} as const

const StyledSportImage = styled(FreeRatioImage)`
  flex-shrink: 0;
`

const SportImage: FunctionComponent = () => (
  <StyledSportImage
    src={IMAGE.src}
    alt={IMAGE.alt}
    crops={IMAGE.crops}
    originalDimensions={{
      width: IMAGE.width,
      height: IMAGE.height,
    }}
    constraints={constraints}
  />
)

export default SportImage
